
  export const versionInfo = {
    commitHash: "77ded46",
    branchName: "HEAD",
    tag: "unknown",
    buildDate: "2026-03-03T19:56:29.480Z"
  };
